import {
  useRemoteVideoTileState,
  useRosterState,
} from 'amazon-chime-sdk-component-library-react'
import { useTranslation } from 'react-i18next'
import type { VideoWallTile } from './types'
import { type CameraNameTranslations, getCameraName } from './utils'

export const useVideoTiles = (): VideoWallTile[] => {
  const { t } = useTranslation()
  const { roster } = useRosterState()
  const { tiles, tileIdToAttendeeId } = useRemoteVideoTileState()
  const cameraNameTranslations: CameraNameTranslations = {
    cabin: cameraNumber =>
      t('adFleetMap_videoStreamCameraCabin_label', { cameraNumber }),
    front: t('adFleetMap_videoStreamCameraFront_label'),
    frontLeft: t('adFleetMap_videoStreamCameraFrontLeft_label'),
    frontRight: t('adFleetMap_videoStreamCameraFrontRight_label'),
    rear: t('adFleetMap_videoStreamCameraRear_label'),
  }

  return tiles
    .map(tileId => {
      const attendee = roster[tileIdToAttendeeId[tileId]] ?? undefined
      if (attendee?.externalUserId?.includes('camera')) {
        const rawName = attendee.externalUserId.split('#')[1]
        const number = Number(rawName.split('-').pop())
        return {
          id: tileId,
          name: getCameraName(number, rawName, cameraNameTranslations),
          number,
        }
      } else {
        return undefined
      }
    })
    .filter(tile => tile !== undefined)
    .sort((a, b) => a.number - b.number)
}
